export default {
  app: {
    golf: {
      title: 'Pályainformációk',
      hasEVChargingPoint: 'EV töltőpont',
      hasCaddieService: 'Caddie szolgáltatás',
      hasTrolley: 'Trolley',
      hasBuggy: 'Buggy',
      hasClubRental: 'Ütőkölcsönzés',
      hasAcademy: 'Akadémia',
      hasMarshal: 'Marshal',
      hasPGACertification: 'PGA tanúsítvány',
      hasTrainingArea: 'Gyakorlóterület',
      hasRestaurant: 'Étterem',
      hasHotel: 'Szálloda',
      hasDogsOnCourse: 'Kutyák a pályán',
      numberOfHoles: 'Lyukak száma',
    },
  },
};
